const BASE_URL = "https://deetyasoft.com/api";

export default BASE_URL;

// https://webapi.deetyasoft.com
